import PropTypes from 'prop-types'
import { useFlag } from '@calendly/feature-check-react'
import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Avatar, CompanyLogo, EventTypeName, Name, ProfileContainer } from '@calendly/booking-kit'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=Container";
import _RedesignDesktopBrandBlock from "index-RedesignDesktopBrandBlock.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignDesktopBrandBlock";
import _RedesignTabletLogoOuter from "index-RedesignTabletLogoOuter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletLogoOuter";
import _RedesignTabletLogoInner from "index-RedesignTabletLogoInner.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletLogoInner";
import _RedesignLogoCard from "index-RedesignLogoCard.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignLogoCard";
import _RedesignLogoImage from "index-RedesignLogoImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignLogoImage";
import _RedesignAvatarRingOverlap from "index-RedesignAvatarRingOverlap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignAvatarRingOverlap";
import _RedesignTabletAvatarRow from "index-RedesignTabletAvatarRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignTabletAvatarRow";
import _RedesignAvatarRingStacked from "index-RedesignAvatarRingStacked.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignAvatarRingStacked";
import _RedesignAvatarImage from "index-RedesignAvatarImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/profile/index.js?styleId=RedesignAvatarImage";

const spacing0_25x = 'var(--spacing-0-25x, 0.25rem)'
const spacing0_75x = 'var(--spacing-0-75x, 0.75rem)'
const spacing1_25x = 'var(--spacing-1-25x, 1.25rem)'
const spacing1_5x = 'var(--spacing-1-5x, 1.5rem)'
const spacing1_5xNegative = 'var(--spacing-1-5x-negative, -1.5rem)'
const spacing1x = 'var(--spacing-1x, 1rem)'
const spacing2_5x = 'var(--spacing-2-5x, 2.5rem)'
const spacing3_5x = 'var(--spacing-3-5x, 3.5rem)'
const spacing4_5x = 'var(--spacing-4-5x, 4.5rem)'

const Container = /*#__PURE__*/styled(ProfileContainer, null, {
  displayName: "Container",
  styles: _Container
})

const RedesignDesktopBrandBlock = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignDesktopBrandBlock",
  styles: _RedesignDesktopBrandBlock
})

const RedesignTabletLogoOuter = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletLogoOuter",
  styles: _RedesignTabletLogoOuter
})

const RedesignTabletLogoInner = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletLogoInner",
  styles: _RedesignTabletLogoInner
})

const RedesignLogoCard = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignLogoCard",
  styles: _RedesignLogoCard
})

const RedesignLogoImage = /*#__PURE__*/styled('img', null, {
  displayName: "RedesignLogoImage",
  styles: _RedesignLogoImage
})

const RedesignAvatarRingOverlap = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignAvatarRingOverlap",
  styles: _RedesignAvatarRingOverlap
})

const RedesignTabletAvatarRow = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTabletAvatarRow",
  styles: _RedesignTabletAvatarRow
})

const RedesignAvatarRingStacked = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignAvatarRingStacked",
  styles: _RedesignAvatarRingStacked
})

const RedesignAvatarImage = /*#__PURE__*/styled('img', null, {
  displayName: "RedesignAvatarImage",
  styles: _RedesignAvatarImage
})

const Profile = ({
  avatar = null,
  eventTypeName = null,
  logoUrl = null,
  name = null,
  reduced = false,
  sidebar = false
}) => {
  const isPhone = useDeviceType('isPhone')
  const isDesktopUp = useDeviceType('isDesktopUp')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const hideWhenReduced = reduced && isPhone
  const nameTag = eventTypeName ? 'div' : 'h1'
  const logoVisible = sidebar && Boolean(logoUrl)
  const showRedesignBrand = bookingAppRedesign && logoVisible
  const companyLogoAlt = name ? `${name} logo` : 'Company logo'

  const logoCard = (
    <RedesignLogoCard isDesktopUp={isDesktopUp}>
      <RedesignLogoImage isDesktopUp={isDesktopUp} src={logoUrl} alt={companyLogoAlt} />
    </RedesignLogoCard>
  )

  const avatarInRing = avatar && !hideWhenReduced && (
    <RedesignAvatarImage src={avatar} alt={name || ''} />
  )

  return (
    <Container reducedView={reduced} bookingAppRedesign={bookingAppRedesign}>
      {showRedesignBrand && isDesktopUp && (
        <RedesignDesktopBrandBlock data-profile="redesign-desktop-brand">
          {logoCard}
          {avatarInRing && (
            <RedesignAvatarRingOverlap data-profile="redesign-desktop-avatar">
              {avatarInRing}
            </RedesignAvatarRingOverlap>
          )}
        </RedesignDesktopBrandBlock>
      )}
      {showRedesignBrand && !isDesktopUp && (
        <>
          <RedesignTabletLogoOuter data-profile="redesign-tablet-logo">
            <RedesignTabletLogoInner>
              {logoCard}
            </RedesignTabletLogoInner>
          </RedesignTabletLogoOuter>
          {avatarInRing && (
            <RedesignTabletAvatarRow data-profile="redesign-tablet-avatar">
              <RedesignAvatarRingStacked>
                {avatarInRing}
              </RedesignAvatarRingStacked>
            </RedesignTabletAvatarRow>
          )}
        </>
      )}
      {!showRedesignBrand && (
        <>
          {logoVisible && <CompanyLogo url={logoUrl} />}
          {avatar && !hideWhenReduced && (
            <Avatar src={avatar} alt={name} withLogo={logoVisible} sidebarView={sidebar} />
          )}
        </>
      )}
      {name && !hideWhenReduced && <Name as={nameTag} sidebarView={sidebar}>{name}</Name>}
      {eventTypeName && <EventTypeName sidebarView={sidebar}>{eventTypeName}</EventTypeName>}
    </Container>
  )
}

Profile.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  eventTypeName: PropTypes.string,
  reduced: PropTypes.bool,
  sidebar: PropTypes.bool
}

export default Profile
